// Lets non-React modules (axios interceptors) trigger a toast without
// needing access to the React tree. ToastProvider registers its addToast
// on mount; anything can call notifyRequestTimeout() after that.
let handler = null;

export const registerToastHandler = (fn) => {
  handler = fn;
};

const THROTTLE_MS = 10000;
let lastShownAt = 0;

export const notifyRequestTimeout = (url) => {
  if (!handler) return;
  const now = Date.now();
  if (now - lastShownAt < THROTTLE_MS) return; // avoid a flood of identical toasts
  lastShownAt = now;
  handler({
    type: 'error',
    title: 'Request Timed Out',
    message: `The server took too long to respond${url ? ` (${url})` : ''}. Please check your connection and try again.`,
    duration: 7000,
  });
};
